import React, { FC, useCallback, useContext, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useFormik } from 'formik';
import PageWrapper from '../../../layout/PageWrapper/PageWrapper';
import Page from '../../../layout/Page/Page';
import Card, { CardBody } from '../../../components/bootstrap/Card';
import FormGroup from '../../../components/bootstrap/forms/FormGroup';
import Input from '../../../components/bootstrap/forms/Input';
import Button from '../../../components/bootstrap/Button';
import Logo from '../../../components/Logo';
import useDarkMode from '../../../hooks/useDarkMode';
import AuthContext from '../../../contexts/authContext';
import USERS, { getUserDataWithUsername } from '../../../common/data/userDummyData';
import Spinner from '../../../components/bootstrap/Spinner';
import Alert from '../../../components/bootstrap/Alert';
import axios from '../../../axios';
import services from '../../../services';
import LogoWithText from '../../../assets/logos/dydwithlogoadntext.png';
import Icon from '../../../components/icon/Icon';
import Checks from '../../../components/bootstrap/forms/Checks';

interface ILoginHeaderProps {
	isNewUser?: boolean;
}
const LoginHeader: FC<ILoginHeaderProps> = ({ isNewUser }) => {
	if (isNewUser) {
		return (
			<>
				<div className='text-center h1 fw-bold mt-5'>Create Account,</div>
				<div className='text-center h4 text-muted mb-5'>Sign up to get started!</div>
			</>
		);
	}
	return (
		<>
			<div className='text-center h1 fw-bold mt-5'>Welcome,</div>
			<div className='text-center h4 text-muted mb-5'>Sign in to continue!</div>
		</>
	);
};
LoginHeader.defaultProps = {
	isNewUser: false,
};

interface ILoginProps {
	isSignUp?: boolean;
}
const Login: FC<ILoginProps> = ({ isSignUp }) => {
	const { setUser } = useContext(AuthContext);
	const [error, setError] = React.useState(null);
    const [showPassword, setShowPassword] = useState(false);

	const { darkModeStatus } = useDarkMode();

	const [signInPassword, setSignInPassword] = useState<boolean>(false);
	const [correctLogin, setcorrectLogin] = useState<boolean>(true);
	const [singUpStatus, setSingUpStatus] = useState<boolean>(!!isSignUp);

	const navigate = useNavigate();
	const handleOnClick = useCallback(() => navigate('/'), [navigate]);

	const usernameCheck = (username: string) => {
		return !!getUserDataWithUsername(username);
	};

	const passwordCheck = (username: string, password: string) => {
		return getUserDataWithUsername(username).password === password;
	};
	// useEffect(() => {
	// 	const handleBlur = () => {
	// 		alert('Screenshot tidak diizinkan!');
	// 	};

	// 	window.addEventListener('blur', handleBlur);

	// 	return () => {
	// 		window.removeEventListener('blur', handleBlur);
	// 	};
	// }, []);

	const handleKeyDown = (event: any) => {
		if (event.key === 'Enter') {
			event.preventDefault(); // Prevent default form submission
			formik.handleSubmit();
		}
	};
    const handleCheckboxChange = (e: any) => {
        const { name, checked } = e.target;
        formikshowpassword.setFieldValue('isshow', checked);
        formikshowpassword.handleSubmit()
        
    };
	const [isLoading, setIsLoading] = useState<boolean>(false);
    const formikshowpassword = useFormik({
        initialValues: {
            isshow: false
        },
        onSubmit: (values) => {
            setShowPassword(values.isshow)
            // alert(JSON.stringify(values, null, 2));
        },
    });
	const formik = useFormik({
		enableReinitialize: true,
		initialValues: {
			loginUsername: '',
			loginPassword: '',
		},
		validate: (values) => {
			const errors: { loginUsername?: string; loginPassword?: string } = {};

			if (!values.loginUsername) {
				errors.loginUsername = 'Required';
			}

			if (!values.loginPassword) {
				errors.loginPassword = 'Required';
			}

			return errors;
		},
		validateOnChange: false,
		onSubmit: async (values) => {
			setcorrectLogin(true);
			setIsLoading(true);
			const body = {
				object: 'pengguna-login',
				username: values.loginUsername,
				password: values.loginPassword,
			};
			try {
				const resp = await services.auth.login(body);
				if (resp.data.statcode === 0) {
					setIsLoading(false);
					if (setUser) {
						setUser(resp.data.data[0].token);
					}
					sessionStorage.setItem('data', JSON.stringify(resp.data.data[0]));
					handleOnClick();
				} else {
					setIsLoading(false);
					setcorrectLogin(false);
				}
				// eslint-disable-next-line @typescript-eslint/no-shadow
			} catch (error: any) {
				setIsLoading(false);
				if (error.response && error.response.status === 401) {
					setIsLoading(false);
					setcorrectLogin(false);
				} else {
					setError(error.response.data.message);
				}
			}
		},
	});

	return (
		<PageWrapper
			isProtected={false}
			title={singUpStatus ? 'Sign Up' : 'Login'}
			className={classNames({ 'bg-dark': !singUpStatus, 'bg-light': singUpStatus })}>
			<Page className='p-0'>
				<div className='row h-100 align-items-center justify-content-center'>
					<div className='col-xl-4 col-lg-6 col-md-8 shadow-3d-container'>
						<Card className='shadow-3d-dark' data-tour='login-page'>
							<CardBody>
								<div className='text-center my-5'>
									<Link
										to='/'
										className={classNames(
											'text-decoration-none  fw-bold display-2',
											{
												'text-dark': !darkModeStatus,
												'text-light': darkModeStatus,
											},
										)}
										aria-label='Facit'>
										{/* <Logo width={200} /> */}
                                        <img
                                            srcSet={LogoWithText}
                                            src={LogoWithText}
                                            alt='Avatar'
                                            width={250}
                                            height={80}
                                        />
									</Link>
								</div>
								<div
									className={classNames('rounded-3', {
										'bg-l10-dark': !darkModeStatus,
										'bg-dark': darkModeStatus,
									})}>
									<div className='row row-cols-2 g-3 pb-3 px-3 mt-0 d-flex justify-content-center'>
										<div className='col'>
											{/* <Button
												color={darkModeStatus ? 'light' : 'dark'}
												isLight={singUpStatus}
												className='rounded-1 w-100'
												size='lg'
												// onClick={() => {
												// 	setSignInPassword(false);
												// 	setSingUpStatus(!singUpStatus);
												// }}
                                                >
												Login
											</Button> */}
										</div>
										{/* <div className='col'>
											<Button
												color={darkModeStatus ? 'light' : 'dark'}
												isLight={!singUpStatus}
												className='rounded-1 w-100'
												size='lg'
												onClick={() => {
													setSignInPassword(false);
													setSingUpStatus(!singUpStatus);
												}}>
												Sign Up
											</Button>
										</div> */}
									</div>
								</div>

								<LoginHeader isNewUser={singUpStatus} />
								{/* <Alert isLight icon='Lock' isDismissible>
									<div className='row'>
										<div className='col-12'>
											<strong>Username:</strong> abiyyu
										</div>
										<div className='col-12'>
											<strong>Password:</strong> @Biyyu241198
										</div>
									</div>
								</Alert> */}
								<form className='row g-4'>
									{singUpStatus ? (
										<>
											<div className='col-12'>
												<FormGroup
													id='signup-email'
													isFloating
													label='Your email'>
													<Input type='email' autoComplete='email' />
												</FormGroup>
											</div>
											<div className='col-12'>
												<FormGroup
													id='signup-name'
													isFloating
													label='Your name'>
													<Input autoComplete='given-name' />
												</FormGroup>
											</div>
											<div className='col-12'>
												<FormGroup
													id='signup-surname'
													isFloating
													label='Your surname'>
													<Input autoComplete='family-name' />
												</FormGroup>
											</div>
											<div className='col-12'>
												<FormGroup
													id='signup-password'
													isFloating
													label='Password'>
													<Input
														type='password'
														autoComplete='password'
													/>
												</FormGroup>
											</div>
											<div className='col-12'>
												<Button
													color='info'
													className='w-100 py-3'
													onClick={handleOnClick}>
													Sign Up
												</Button>
											</div>
										</>
									) : (
										<>
											<div className='col-12'>
												<FormGroup
													id='loginUsername'
													isFloating
													label='Your email or username'>
													<Input
														autoComplete='username'
														value={formik.values.loginUsername}
														// isTouched={formik.touched.loginUsername}
														invalidFeedback={
															formik.errors.loginUsername
														}
														isValid={formik.isValid}
														onChange={formik.handleChange}
														onBlur={formik.handleBlur}
														onFocus={() => {
															formik.setErrors({});
														}}
													/>
												</FormGroup>
											</div>
											<div className='col-12'>
												<FormGroup
													id='loginPassword'
													isFloating
													label='Password'>
													<Input
														type={showPassword ? 'text' : 'password'}
														autoComplete='current-password'
														value={formik.values.loginPassword}
														// isTouched={formik.touched.loginPassword}
														invalidFeedback={
															formik.errors.loginPassword
														}
														validFeedback='Looks good!'
														isValid={formik.isValid}
														onChange={formik.handleChange}
														onKeyDown={handleKeyDown}
														onBlur={formik.handleBlur}
													/>
                                                    {/* <label className='border-0 bg-transparent cursor-pointer' onClick={() => setShowPassword(!showPassword)}>
                                                        <Icon icon='RemoveRedEye' size='2x' color='primary' />
                                                    </label> */}
												</FormGroup>
											</div>
											<div className='col-12'>
												<FormGroup>
                                                    <Checks
                                                        type="checkbox"
                                                        id="isshow"
                                                        label={
                                                            <>
                                                            show password
                                                            </>
                                                        }
                                                        style={{
                                                            marginRight: "8px",
                                                            border: "2px solid green",
                                                        }}
                                                        onChange={handleCheckboxChange}
                                                        checked={formikshowpassword.values.isshow}
                                                    />
												</FormGroup>
											</div>
											{!correctLogin && (
												<Alert
													borderWidth={0}
													color='danger'
													isDismissible
													isLight>
													Username atau Password Salah.
												</Alert>
											)}
											<div className='col-12'>
												<Button
													color='danger'
													className='w-100 py-3'
													onClick={formik.handleSubmit}>
													{isLoading && (
														<Spinner isSmall inButton isGrow />
													)}
													Login
												</Button>
											</div>
										</>
									)}

									{/* BEGIN :: Social Login */}
									{/* {!signInPassword && (
										<>
											<div className='col-12 mt-3 text-center text-muted'>
												OR
											</div>
											<div className='col-12 mt-3'>
												<Button
													isOutline
													color={darkModeStatus ? 'light' : 'dark'}
													className={classNames('w-100 py-3', {
														'border-light': !darkModeStatus,
														'border-dark': darkModeStatus,
													})}
													icon='CustomApple'
													onClick={handleOnClick}>
													Sign in with Apple
												</Button>
											</div>
											<div className='col-12'>
												<Button
													isOutline
													color={darkModeStatus ? 'light' : 'dark'}
													className={classNames('w-100 py-3', {
														'border-light': !darkModeStatus,
														'border-dark': darkModeStatus,
													})}
													icon='CustomGoogle'
													onClick={handleOnClick}>
													Continue with Google
												</Button>
											</div>
										</>
									)} */}
									{/* END :: Social Login */}
								</form>
							</CardBody>
						</Card>
						<div className='text-center'>
							<a
								href='/'
								className={classNames('text-decoration-none me-3', {
									'link-light': singUpStatus,
									'link-dark': !singUpStatus,
								})}>
								Privacy policy
							</a>
							<a
								href='/'
								className={classNames('link-light text-decoration-none', {
									'link-light': singUpStatus,
									'link-dark': !singUpStatus,
								})}>
								Terms of use
							</a>
						</div>
					</div>
				</div>
			</Page>
		</PageWrapper>
	);
};
Login.propTypes = {
	isSignUp: PropTypes.bool,
};
Login.defaultProps = {
	isSignUp: false,
};

export default Login;
